import { combineReducers } from '@reduxjs/toolkit';
import siteIdSlice from './siteId';

export const rootReducer = combineReducers({
  [siteIdSlice.name]: siteIdSlice.reducer,
});
